/* eslint-disable no-autofix/jsdoc/require-jsdoc */
import { useQueryClient } from '@tanstack/react-query';

import { getTsPharmacyClient } from '@montugroup/circuit-shared/api/pharmacy.client';
import type { DispatchedConsignmentStatus } from '@montugroup/contracts-warehousing-api';

export type UseGetPharmacistShipmentsParams = {
  pageSize: number;
  referenceFilter?: string;
  statusFilter?: DispatchedConsignmentStatus[];
  sortField?: string;
  sortDirection?: 'asc' | 'desc';
  beforeCursor?: string | null;
  afterCursor?: string | null;
  signal?: AbortSignal;
};

const client = getTsPharmacyClient();

const useGetPharmacistReplenishmentOrders = () => {
  const queryClient = useQueryClient();
  return client.listReplenishmentOrderItems.useMutation({
    meta: {
      error: {
        showToast: false,
        log: 'Failed to retrieve replenishment orders for pharmacist',
        message: 'Something went wrong while retrieving the replenishment orders',
      },
    },
    onSuccess: (result) => {
      queryClient.setQueryData(client.listReplenishmentOrderItems.keys, result);
    },
  });
};

export default useGetPharmacistReplenishmentOrders;
